export default __webpack_public_path__ + "static/media/whatsapp.68e064a0.svg";